module.exports = __webpack_public_path__ + "fdc6a4b42a5d795997a6c5da0912d449.jpg";